const initialState = {
  resaleEventData: [],
  ticketDetails:[],
  selectedCategory: null,
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch (type) {
  case 'RESALE_EVENT_DATA:SET':
    return {
      ...state,
      resaleEventData: data,
    };
  case 'TICKET_DETAILS:SET':
    return {
      ...state,
      ticketDetails: data,
    }
  case 'TICKET_DETAILS:SELECTED_CATEGORY:SET':
    return {
      ...state,
      selectedCategory: data,
    }
  case 'TICKET_DETAILS:RESET':
    return {
      ...state,
      ...initialState,
    }
  default:
    return state;
  }
};
